module.exports = __webpack_public_path__ + "static/media/Attachment.bd020114.svg";